import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RestService } from 'app/services/rest/rest.service';
import { AppService } from 'app/services/app/app.service';

export interface AuxDialogData {
  title: string;
  message: string;
}

interface DiscountCodeItem {
  locationId: number;
  locationName: string;
  code: string;
}

@Component({
    selector: 'aux-dialog',
    templateUrl: './aux-dialog.component.html',
    styleUrls: ['./aux-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuxDialogComponent implements OnInit {
  
  discountCodes: DiscountCodeItem[] = [];
  commissionLink:string = '';

  constructor(
    public dialogRef: MatDialogRef<AuxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AuxDialogData,
    private clipboard: Clipboard,
    private snack: MatSnackBar,
    private appService: AppService,
    private restService: RestService
  ) {}


  ngOnInit(): void {
    this.getWalletMovements();
  }


  onClose(): void {
    this.dialogRef.close();
  }

  saveClipboard(clipboardText:string){
    this.clipboard.copy(clipboardText);
    this.snack.open(
      this.appService.getTraduccion('clipboard.msg'), 
      this.appService.getTraduccion('clipboard.action'), 
      { duration: 3000 });
  }

  getWalletMovements(){
    this.restService.getCommissionLink().subscribe(result => {
      this.discountCodes = Array.isArray(result?.discountCodes) ? result.discountCodes : [];
      this.commissionLink = result?.commissionLink ?? '';
    });
  }
  
}
